
import { isAbsolutePath, isCx5, itemType } from './util';


import { mocksEnabled, bundlesEnabled } from './dev';


const getModuleFile = (name) =>
  ((name.indexOf('/') !== -1) ? name : `${name}/scripts/${name}.js`);

const getModuleRoot = (name, version, staticResourcesRoot) => ((isCx5(version))
  ? `${staticResourcesRoot}/${itemType(name)}/%5BBBHOST%5D`
  : staticResourcesRoot);

const nameToPath = (name, version, staticResourcesRoot) => {
  if (isAbsolutePath(name)) {
    return name.replace('[BBHOST]', '%5BBBHOST%5D');
  }

  
  if (mocksEnabled() && name.indexOf('data-') === 0) {
    name = `mock.${name}`; // eslint-disable-line no-param-reassign
    console.log('load mock', name); // eslint-disable-line no-console
  }
  

  const moduleRoot = getModuleRoot(name, version, staticResourcesRoot);
  const moduleFile = getModuleFile(name);

  return `${moduleRoot}/${moduleFile}`;
};

const systemJsConfig = (config, bundleDefinition) => {
  
  if (!bundlesEnabled()) {
    bundleDefinition = []; // eslint-disable-line no-param-reassign
  }
  
  // Get bundles that are relevant for the current page.
  const itemPath = name => nameToPath(name, config.version, config.staticResourcesRoot);
  const bundles = {};
  const map = {};
  for (let i = 0; i < bundleDefinition.length; i++) {
    const bundle = bundleDefinition[i];
    if (bundle.portal) {
      if (config.portalName !== bundle.portal) continue;
      if (bundle.page && config.pageName !== bundle.page) continue;
    }
    const bundleName = `bundle${i}`;
    const bundlePath = itemPath(bundle.path);
    bundles[bundlePath] = bundle.dependencies;
    map[bundleName] = bundlePath;
    bundle.dependencies.forEach(dep =>
      (map[dep] = itemPath(dep))
    );
  }

  const systemNormalize = System.normalize;
  const systemTranslate = System.translate;
  return {
    bundles,
    map,
    normalize(name, parentName, isPlugin) {
      return systemNormalize.call(this, itemPath(name), parentName, isPlugin);
    },
    translate(load, ...args) {
      if (load.name.indexOf('.json') === load.name.length - 5) {
        return `module.exports = ${load.source};`;
      }
      return systemTranslate.call(this, load, ...args);
    },
  };
};

export default systemJsConfig;



// WEBPACK FOOTER //
// ./config-bb-module-loader/scripts/system.js